import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import BannerLanding from '../components/BannerLanding'

import data from '../data/digital-realities'

//
// import hero from '../assets/images/banner_brand-design.jpg'
// import processDiscover from '../assets/images/process-discover.jpg'
// import processDefine from '../assets/images/process-define.jpg'
// import processDesign from '../assets/images/process-design.jpg'
// import processBuild from '../assets/images/process-build.jpg'
class DigitalRealities extends React.Component {

    render() {
        
        let projects = data.map( (project, idx) => (
            <article key={`project-${project.name}`} id={project.id} onClick={this.props.handleClick.bind(this, idx)}>
                <Link to={project.url} className="link primary"></Link>
                    <img src={project.img} />
            </article>
        ));

        return(
            <div>
                <Helmet>
                    <title>IMBIBE - Brand Design</title>
                    <meta name="description" content="Brand Design Landing Page" />
                    <link href="//cloud.webtype.com/css/205c6ee8-8be6-4e77-9137-0a8616dac421.css" rel="stylesheet" type="text/css" />

                </Helmet>

                <div id="main">
                    <section id="one" className="tiles">
                        {projects}
                    </section>
                </div>
            </div>
        )
    }
}

export default DigitalRealities


// WEBPACK FOOTER //
// ./src/pages/digital-realities.js